import { GlDropdownDivider, GlDropdownSectionHeader, GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { groupByIterationCadences, getIterationPeriod } from 'ee/iterations/utils';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { TYPENAME_ITERATIONS_CADENCE } from '~/graphql_shared/constants';
import { convertToGraphQLId, getIdFromGraphQLId } from '~/graphql_shared/utils';
import { NAMESPACE_GROUP, NAMESPACE_PROJECT } from '~/issues/constants';
import { __ } from '~/locale';
import { OPERATOR_IS } from '~/vue_shared/components/filtered_search_bar/constants';
import BaseToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/filtered_search_bar/tokens/base_token.vue?vue3';
import IterationTitle from 'ee/iterations/components/iteration_title.vue';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { DEFAULT_CADENCES, DEFAULT_ITERATIONS } from '../constants';
import searchIterationCadencesQuery from '../queries/search_iteration_cadences.query.graphql';
export default {
    name: 'IterationToken',
    components: {
        BaseToken,
        GlDropdownDivider,
        GlDropdownSectionHeader,
        GlFilteredSearchSuggestion,
        IterationTitle
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        active: {
            type: Boolean,
            required: true
        },
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            iterations: this.config.initialIterations || [],
            loading: false
        };
    },
    computed: {
        defaultIterations () {
            return this.config.defaultIterations || DEFAULT_ITERATIONS;
        },
        defaultCadenceOptions () {
            return !this.config.hideDefaultCadenceOptions && this.value.operator === OPERATOR_IS ? DEFAULT_CADENCES : [];
        },
        namespace () {
            return this.config.isProject ? NAMESPACE_PROJECT : NAMESPACE_GROUP;
        }
    },
    methods: {
        getActiveIteration (iterations, data) {
            if (data?.includes('&')) {
                const iterationCadenceId = this.getIterationCadenceId(data);
                const iteration = iterations.find((i)=>i?.iterationCadence?.id === convertToGraphQLId(TYPENAME_ITERATIONS_CADENCE, iterationCadenceId));
                return iteration?.iterationCadence;
            }
            return iterations.find((iteration)=>this.getId(iteration) === data);
        },
        groupIterationsByCadence (iterations) {
            return groupByIterationCadences(iterations);
        },
        fetchIterationCadences (searchTerm) {
            const id = Number(searchTerm);
            let variables = {
                fullPath: this.config.fullPath,
                title: searchTerm,
                isProject: this.config.isProject
            };
            if (!Number.isNaN(id) && searchTerm !== '') {
                variables = {
                    fullPath: this.config.fullPath,
                    id: convertToGraphQLId(TYPENAME_ITERATIONS_CADENCE, id),
                    isProject: this.config.isProject
                };
            }
            return this.$apollo.query({
                query: searchIterationCadencesQuery,
                variables
            }).then(({ data })=>{
                return data[this.namespace]?.iterationCadences?.nodes;
            });
        },
        fetchIterations (searchTerm) {
            this.loading = true;
            if (searchTerm?.includes('&')) {
                this.fetchIterationCadences(this.getIterationCadenceId(searchTerm)).then((response)=>{
                    this.iterations = [
                        {
                            iterationCadence: response[0]
                        }
                    ];
                }).catch((error)=>{
                    createAlert({
                        message: this.$options.i18n.errorMessage,
                        captureError: true,
                        error
                    });
                }).finally(()=>{
                    this.loading = false;
                });
            } else {
                this.config.fetchIterations(searchTerm).then((response)=>{
                    this.iterations = Array.isArray(response) ? response : response.data;
                }).catch(()=>{
                    createAlert({
                        message: this.$options.i18n.errorMessage
                    });
                }).finally(()=>{
                    this.loading = false;
                });
            }
        },
        getId (option) {
            return getIdFromGraphQLId(option.id ?? option.iterationCadence?.id).toString();
        },
        getIterationCadenceId (input) {
            return input.split('&')[1];
        },
        getIterationOption (input) {
            return input.split('&')[0];
        },
        iterationTokenText (iterationOrCadence, inputValue) {
            if (iterationOrCadence?.id?.includes(TYPENAME_ITERATIONS_CADENCE)) {
                return `${this.getIterationOption(inputValue)}::${iterationOrCadence.title}`;
            }
            const cadenceTitle = iterationOrCadence.iterationCadence.title;
            return `${cadenceTitle} ${getIterationPeriod(iterationOrCadence)}`;
        }
    },
    i18n: {
        errorMessage: __('There was a problem fetching iterations.')
    }
};
